export default "/images/pfiqScore.svg?754fdce8db3bed6800c5616de1089bbb";